
import BaseHttpClient from '@/core/HttpResources/BaseHttpClient';
import { EXTERNAL_STATUS_HTTP_TIMEOUT, HttpRequestOptions } from '@/core/HttpResources/BaseApi';
class ExternalService {
    private client: BaseHttpClient;
    constructor(public controller: string = 'external') {
        this.client = new BaseHttpClient(controller);
    }
    async ExisteMiembroEnOtroHogarSiuben(cedulaJefe: string, cedula: string, requestOptions?: HttpRequestOptions): Promise<boolean> {
        var result = await this.client.getAsync<boolean>('ps/ciudadano/ExisteMiembroEnOtroHogarSiuben', { cedula, cedulaJefe }, { timeoutMs: EXTERNAL_STATUS_HTTP_TIMEOUT, ...requestOptions })
        return result;
    }
    async ExisteMiembroEnOtroHogar(codigoHogar:string, cedula: string): Promise<boolean> {
        var result = await this.client.getAsync<boolean>('ps/ciudadano/ExisteMiembroEnOtroHogar', { cedula, codigoHogar  })
        return result;
    }
    async verificarEstadoEnInstituciones(cedula: string, requestOptions?: HttpRequestOptions): Promise<any> {
        var result = await this.client.getAsync('ps/ciudadano/VerificarEstadoEnInstituciones', { cedula }, { timeoutMs: EXTERNAL_STATUS_HTTP_TIMEOUT, ...requestOptions })
        return result;
    }
    async getDatosSiuben(cedula: string, requestOptions?: HttpRequestOptions): Promise<any> {
        var result = await this.client.getAsync('siuben/consulta/ciudadano', { cedula }, { timeoutMs: EXTERNAL_STATUS_HTTP_TIMEOUT, ...requestOptions })
        return result;
    }
    async getDatosBeneficiario(cedula: string): Promise<any> {
        var result = await this.client.getAsync('prosoli/consulta/hogarByCedula', { cedula })
        return result;
    }
}

export default new ExternalService();
